<!-- mobile satellites and alpi -->
@if (variationLogo === '') {
  <a
    class="header-logo-link d-inline-flex d-lg-none"
    aria-label="Logo"
    [routerLink]="['/SKIHIREENTRY'] | localize"
    [class.with-partner-referer]="shouldDisplayPartnerRefererLogo">
    <div style="position: relative; overflow: hidden">
      <img
        class="py-1 header-image"
        src="{{ 'images/logo-mobile.png' | platformasset: true : true }}"
        alt="{{ productName }}"
        [width]="logoWidth"
        [height]="logoHeight" />
      @if (platformcode === 'ar') {
        <img
          class="alpy"
          alt="Alpy.com"
          [src]="'images/alpy-logo-mobile.svg' | platformasset: true"
          @alpyIn />
      }
    </div>

    <!-- partner-referer-logo from, well, referer links -->
    @if (shouldDisplayPartnerRefererLogo && isBrowser) {
      <div class="partner-referer-brand-logo-wrapper">
        <div class="partner-referer-brand-logo">
          <div
            class="partner-referer-brand-background"
            [style.background-color]="partnerLogo.brand_logo_background_color"
            [style.border]="'1px solid ' + partnerLogo.brand_logo_background_color">
            <img
              alt="{{ partnerLogo.brand_name }}"
              src="{{ '/uploads/images/alpinpartnerreferer/' + partnerLogo.brand_logo | platformurl }}" />
          </div>
        </div>
      </div>
    }
  </a>
} @else {
  <!-- mobile microsites -->
  <img
    class="p-1 header-image color-bg d-block d-lg-none"
    src="{{ variationLogo | platformurl }}"
    alt="{{ productName }}" />
}
<!-- desktop satellites and alpi -->
@if (variationLogo === '') {
  <a
    class="mt-2 header-logo-link d-none d-lg-inline-block"
    aria-label="Logo"
    [class.color-bg]="shouldDisplayPartnerRefererLogo"
    [routerLink]="['/SKIHIREENTRY'] | localize">
    <!-- only alpi has an SVG at the moment -->
    @if (platformcode === 'ar') {
      <!-- we prerender the images on all viewports in html so tell browsers
       on viewport srcset to only load on desktop widths and show a placeholder pixel
       if not. Prevents "don't load unused images" on FCP/LCP  -->
      <div
        class="py-3 px-3 header-image satellite"
        [ngClass]="{ 'color-bg': !shouldDisplayPartnerRefererLogo }">
        <picture>
          <source
            media="(min-width: 1200px)"
            srcset="{{
              currentLang === 'fr'
                ? ('images/alpinresorts-logo-desktop-fr.svg' | platformasset: true)
                : ('images/alpinresorts-logo-desktop.svg' | platformasset: true)
            }} 1200w" />
          <img
            src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw=="
            loading="lazy"
            decoding="async"
            width="228"
            height="46"
            fetchpriority="low"
            alt="{{ productName }}" />
        </picture>
        <picture>
          <source
            media="(min-width: 1200px)"
            srcset="{{'images/alpy-logo.svg?v2' | platformasset: true }} 1200w" />
          <img
            alt="Alpy.com"
            class="alpy"
            width="111"
            height="38"
            src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw=="
            @alpyIn />
        </picture>
      </div>
    }
    @if (platformcode !== 'ar' && platformcode !== 'es') {
      <img
        class="py-3 px-3 header-image satellite"
        [ngClass]="{ 'color-bg': !shouldDisplayPartnerRefererLogo }"
        src="{{ 'images/logo.png' | platformasset: true : true }}"
        alt="{{ productName }}" />
    }
    @if (platformcode === 'es') {
      <img
        class="py-3 px-3 header-image satellite"
        [ngClass]="{ 'color-bg': !shouldDisplayPartnerRefererLogo }"
        src="{{ 'images/logo.png' | platformasset: true : true }}"
        alt="{{ productName }}" />
    }

    <!-- partner-referer-logo from, well, referer links -->
    @if (shouldDisplayPartnerRefererLogo && isBrowser) {
      <div class="mt-2 partner-referer-brand-logo-wrapper">
        <div class="partner-referer-brand-logo">
          <div
            class="partner-referer-brand-background"
            [style.background-color]="partnerLogo.brand_logo_background_color"
            [style.border]="'1px solid ' + partnerLogo.brand_logo_background_color">
            <img
              alt="{{ partnerLogo.brand_name }}"
              src="{{ '/uploads/images/alpinpartnerreferer/' + partnerLogo.brand_logo | platformurl }}" />
          </div>
        </div>
      </div>
    }
  </a>
} @else {
  <!-- desktop simple booking / microsite -->
  <img
    class="mt-3 py-2 px-2 header-image color-bg d-none d-lg-inline-block"
    src="{{ variationLogo | platformurl }}"
    alt="{{ productName }}" />
}
